import React from "react";
import {
  faWhatsapp,
  //   faInstagram,
  // faTelegram,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTelegram,
  faSignalMessenger,
} from "@fortawesome/free-brands-svg-icons";

const supportData = [
  {
    title: "پشتیبانی واتساپ",
    subtitle: "0935 631 2402",
    icon: faWhatsapp,
    link: "https://wa.me/989356312402",
  },
  {
    title: "پیامک",
    subtitle: "0999 961 3076",
    icon: faSignalMessenger,
    link: "sms:09356312402",
  },
  {
    title: "پشتیبانی تلگرام",
    subtitle: "@DoclinkSup",
    icon: faTelegram,
    link: "https://t.me/DoclinkSup",
  },
];

const SupportBox = () => {
  return (
    <div className="border rounded-4 p-3 m-3 ms-md-5 me-md-5" dir="ltr">
      <div className="row justify-content-center text-center gy-4">
        {supportData.map((item, index) => (
          <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-2">
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
            >
              <div className="d-flex flex-column align-items-center gap-2">
                <div className="bg-light rounded-3 p-3 color-green fs-4">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
                <div className="fw-semibold color-blue">{item.title}</div>
                {item.subtitle && (
                  <div className="text-muted small">{item.subtitle}</div>
                )}
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupportBox;
